import React from 'react';
import { ThinkingOrb } from 'thinking-orbs';
import type { OrbState, OrbTheme } from 'thinking-orbs';
import { Alert, Check, Pending } from '../../design/icons';
import { agentActivity } from './activityStates';
import type { BotState } from './motionSystem';

interface AgentActivityProps {
    state: BotState;
    work?: OrbState;
    theme?: OrbTheme;
    paused?: boolean;
}

/** Adjacent text owns the status announcement; motion is supplementary. */
export default function AgentActivity({ state, work, theme = 'auto', paused = false }: AgentActivityProps) {
    const activity = agentActivity(state, work);
    return (
        <span aria-hidden="true" data-agent-activity={activity ?? state}
            style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 20, height: 20, flexShrink: 0 }}>
            {activity ? (
                <ThinkingOrb state={activity} size={20} theme={theme} paused={paused}
                    role="presentation" aria-hidden="true" />
            ) : state === 'done' ? <Check /> : state === 'blocked' ? <Alert /> : <Pending />}
        </span>
    );
}
